const REFERRERS_API_HOST = '/v4/agent-referrals/referrers';
const REFEREES_API_HOST = '/me/referees';
const BANNERS_API_HOST = '/v4/_exclusive/agent-referrals/banners';

export const createVoucher = $axios => $axios.$post(REFERRERS_API_HOST);

export const getBanner = $axios => $axios.$get(`${BANNERS_API_HOST}?active=true`);
export const getReferees = ($axios, status) => {
  let url = REFEREES_API_HOST;
  if (status) url += `?status=${status}`;
  return $axios.$get(url);
};
